import amplitude from 'amplitude-js';

function initAmplitude() {
  if (process.env.NODE_ENV === 'production') {
    amplitude.getInstance().init('6e747eba4d913b9ff8e698d6bbc52703');
  } else {
    amplitude.getInstance().init('14ec2d9e8bba38861977b127274a87ea');
  }
}

export {
 initAmplitude,
};



// WEBPACK FOOTER //
// ./src/amplitude/amplitude.js